// @flow

import { FacebookPage } from './FacebookPage'

// @deprecated, please use Shop
export const Channel = FacebookPage
